import { useEffect, useState } from "react";
import { useAuth, useUser } from "@clerk/react";
import { api } from "../lib/api";
import { money } from "../lib/cart";
import { statusLabel } from "../lib/orders";

export default function Account() {
  const { user } = useUser();
  const { getToken } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = await getToken();
        const r = await api.get("/orders/mine", { headers: { Authorization: `Bearer ${token}` } });
        setOrders(r.data || []);
      } catch { /* unauth */ }
      setLoading(false);
    })();
  }, [getToken]);

  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="account-page">
      <p className="text-xs uppercase tracking-[0.3em] text-[#5E6B51]">Welcome</p>
      <h1 className="font-serif text-5xl mt-2 mb-10">{user?.firstName || "Hello"}</h1>

      <h2 className="font-serif text-2xl mb-5">Your orders</h2>
      {loading ? <p className="text-[#5E4D5A]">Loading…</p> : orders.length === 0 ? (
        <div className="bg-white rounded-2xl border border-[#A8B59A]/20 p-10 text-center text-[#5E4D5A]" data-testid="account-no-orders">
          No orders yet.
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl border border-[#A8B59A]/20 p-5 flex items-center justify-between">
              <div>
                <p className="font-mono text-xs text-[#5E4D5A]">{o.order_number || `#${o.id.slice(0, 8)}`}</p>
                <p className="font-serif text-lg mt-1">{o.items.length} item{o.items.length !== 1 ? "s" : ""}</p>
                <p className="text-xs text-[#5E6B51] uppercase tracking-wider mt-1">{statusLabel(o.status)}</p>
              </div>
              <div className="text-right">
                <p className="font-medium">{money(o.total_cents || o.subtotal_cents)}</p>
                <p className="text-xs text-[#5E4D5A] mt-1">{new Date(o.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
